import { Component, OnInit } from '@angular/core';
import { CommonMessageService } from 'src/app/services/common-message.service';
import { MasterDataService } from '../../services/master-data.service';

@Component({
  selector: 'app-variance-report-excel',
  templateUrl: './variance-report-excel.component.html',
  styleUrls: ['./variance-report-excel.component.css']
})
export class VarianceReportExcelComponent implements OnInit {
  financialList;
  selectedFinancialYear;
  partnerList;
  selectPartner;
  selectedLevel;
  reportList;
  selectCostManDays;
  distinctRoles;
  totalPartnerBudgetedMandays=0;
  totalPartnerActualMandays=0;
  totalPartnerBudgetedMandaysPartnerLevel = 0;
  totalPartnerActualMandaysPartnerLevel = 0;
  constructor(private masterDataService: MasterDataService,private commonMessageService:CommonMessageService) { }

  ngOnInit(): void {
    this.selectedFinancialYear = "";
    this.selectPartner = "";
    this.selectedLevel = "firmLevel";
    this.loadFYDetails();
  }

  loadFYDetails() {
    this.masterDataService.getFinancialYear().subscribe((res) => {
      this.financialList = res;
    });
  }

  onFYSelected() {
    this.reportList=undefined;
    this.showExcelButton=false;
    this.selectPartner="";
      this.getAllPartnerDetails();
  }

  getAllPartnerDetails() {
    this.masterDataService.getAllBudgetedPartner(this.selectedFinancialYear.id).subscribe((res: any) => {
      console.log('partner res', res);
      this.partnerList = res;
    })
  }

  onLevelChange(){
    this.reportList=undefined;
    this.showExcelButton=false;
  }

  showExcelButton:Boolean;
  exportToExcelVarianceReport() {
    console.log('values', this.selectedFinancialYear, this.selectPartner);


    if (this.selectCostManDays == 0) {


    if (this.selectedLevel == "partnerLevel") {
      if (this.selectedFinancialYear == "" || this.selectedFinancialYear == undefined ||
        this.selectPartner == "" || this.selectPartner == undefined) {
        this.commonMessageService.swalAlertWithoutIcon('', 'Please select all fields.');
        return;
      }
      this.masterDataService.getVarianceReportExcelByPartner(this.selectedFinancialYear.id, this.selectPartner.id).subscribe((resp: any) => {
        const blob = new Blob([resp]); // you can change the type
        var downloadURL = window.URL.createObjectURL(blob);
        var link = document.createElement('a');
        link.href = downloadURL;
        link.download = "VariationPartnerLevel.xlsx";
        link.click();
      });
    } else {
      if (this.selectedFinancialYear == "" || this.selectedFinancialYear == undefined) {
        this.commonMessageService.swalAlertWithoutIcon('', 'Please select year.');
        return;
      }
      this.masterDataService.getVarianceReportExcelByYear(this.selectedFinancialYear.id).subscribe((resp: any) => {
        const blob = new Blob([resp]); // you can change the type
        var downloadURL = window.URL.createObjectURL(blob);
        var link = document.createElement('a');
        link.href = downloadURL;
        link.download = "VariationFirmLevel.xlsx";
        link.click();
      });
    }
  }else{

    if (this.selectedLevel == "partnerLevel") {
      if (this.selectedFinancialYear == "" || this.selectedFinancialYear == undefined ||
        this.selectPartner == "" || this.selectPartner == undefined) {
        this.commonMessageService.swalAlertWithoutIcon('', 'Please select all fields.');
        return;
      }
      this.masterDataService.getVarianceSummaryMandaysExcelByPartnerLevel(this.selectPartner.id,this.selectedFinancialYear.id ).subscribe((resp: any) => {
        const blob = new Blob([resp]); // you can change the type
        var downloadURL = window.URL.createObjectURL(blob);
        var link = document.createElement('a');
        link.href = downloadURL;
        link.download = "VariationMandaysPartnerLevel.xlsx";
        link.click();
      });
    } else {
      if (this.selectedFinancialYear == "" || this.selectedFinancialYear == undefined) {
        this.commonMessageService.swalAlertWithoutIcon('', 'Please select year.');
        return;
      }
      this.masterDataService.getVarianceSummaryMandaysExcelByFirmLevel(this.selectedFinancialYear.id).subscribe((resp: any) => {
        const blob = new Blob([resp]); // you can change the type
        var downloadURL = window.URL.createObjectURL(blob);
        var link = document.createElement('a');
        link.href = downloadURL;
        link.download = "VariationMandaysFirmLevel.xlsx";
        link.click();
      });
    }
    



  }
  }

  allTotalBudgetedFee;
  allTotalBudgetedCost;
  allTotalBudgetedContribution;
  allTotalBudgetedContributionPer;
  allTotalActualCost;
  allTotalActualContribution;
  allTotalActualContributionPer;
  allTotalVarianceContribution;
  allTotalVarianceContributionPer

  findDistinctRoles() {
    // Initialize a Set to hold distinct roles
    const roleSet = new Set();

    // Iterate over each partner in variancePartnerRests
    this.reportList.variancePartnerRests.forEach(partner => {
        // Iterate over each role of the current partner and add to the Set
        partner.roles.forEach(({ role }) => {
            roleSet.add(role);
        });
    });

    // Convert the Set to an array and assign it to distinctRoles
    this.distinctRoles = Array.from(roleSet);

    // Log the distinct roles
    console.log('distinct roles', this.distinctRoles);

    // Call the function to handle branch row span
    //this.getBranchRowSpan();
}


findDistinctRolesforPartnerLevel() {
  this.distinctRoles = this.reportList.clients[0].assignments[0].roles.map(({ role }) => role);
  console.log('distinct roles', this.distinctRoles);
  this.getBranchRowSpan();
}


calculateAllTotal() {
  // Reset totals before calculation
  this.totalPartnerBudgetedMandays = 0;
  this.totalPartnerActualMandays = 0;

  // Iterate through each partner in the reportList
  this.reportList.variancePartnerRests.forEach(partner => {
    // Iterate through each role of the current partner
    partner.roles.forEach(role => {
      // Add the budgeted and actual man days to the totals with NaN check
      if (typeof role.budgetedManDays === 'number') {
        this.totalPartnerBudgetedMandays += role.budgetedManDays;
      }

      if (typeof role.actualManDays === 'number') {
        this.totalPartnerActualMandays += role.actualManDays;
      }
    });
  });
}


calculateAllTotalForPartnerLevel() {
  // Initialize totals to zero
  this.totalPartnerBudgetedMandaysPartnerLevel = 0;
  this.totalPartnerActualMandaysPartnerLevel = 0;

  // Iterate over each client
  this.reportList.clients.forEach(client => {
    // Iterate over each assignment within the client
    client.assignments.forEach(assignment => {
      // Iterate over each role within the assignment
      assignment.roles.forEach(role => {
        // Handle NaN values by checking if the value is a valid number
        const budgetedManDays = isNaN(role.budgetedManDays) ? 0 : role.budgetedManDays;
        const actualManDays = isNaN(role.actualManDays) ? 0 : role.actualManDays;

        // Add the valid numbers to the totals
        this.totalPartnerBudgetedMandaysPartnerLevel += budgetedManDays;
        this.totalPartnerActualMandaysPartnerLevel += actualManDays;
      });
    });
  });

  console.log("Total Partner Budgeted Man Days:", this.totalPartnerBudgetedMandaysPartnerLevel);
  console.log("Total Partner Actual Man Days:", this.totalPartnerActualMandaysPartnerLevel);
}


    





  getBranchRowSpan() {
    // const numberOfRows = this.reportList.clients.map(({ assignments }) => assignments.length).reduce((a) => { return a +1 })
    // console.log('total row count', numberOfRows);
    // return numberOfRows * 2;
    var count = 0;
    this.reportList.clients.map((res) => {
      res.assignments.map((res1) => {
        count++;
      });
    });
    return count;
  }

  viewReport() {

    if (this.selectCostManDays == 0) {

      this.allTotalBudgetedFee = 0;
      this.allTotalBudgetedCost = 0;
      this.allTotalBudgetedContribution = 0;
      this.allTotalBudgetedContributionPer = 0;
      this.allTotalActualCost = 0;
      this.allTotalActualContribution = 0;
      this.allTotalActualContributionPer = 0;
      this.allTotalVarianceContribution = 0;
      this.allTotalVarianceContributionPer = 0
      if (this.selectedLevel == "firmLevel") {
        if (this.selectedFinancialYear == null || this.selectedFinancialYear == undefined || this.selectedFinancialYear == "") {
          this.commonMessageService.swalAlertWithoutIcon('', 'Please select the year.');
          this.showExcelButton = false;
          this.reportList = undefined;
          return;
        }
        this.masterDataService.getVarianceSummaryReport(this.selectedFinancialYear.id).subscribe((resp: any) => {
          console.log('response details', resp);
          this.reportList = resp;
          this.showExcelButton = true;
        });
      } else {
        if (this.selectedFinancialYear == null || this.selectedFinancialYear == undefined || this.selectedFinancialYear == "" ||
          this.selectPartner == null || this.selectPartner == undefined || this.selectPartner == "") {
          this.commonMessageService.swalAlertWithoutIcon('', 'Please select the partner & year.');
          this.showExcelButton = false;
          this.reportList = undefined;
          return;
        }
        this.masterDataService.getPartnerVarianceSummaryReport(this.selectedFinancialYear.id, this.selectPartner.id).subscribe((resp: any) => {
          console.log('partner response details', resp);
          this.reportList = resp;
          this.reportList.multi.map((resp: any) => {
            this.allTotalBudgetedFee += resp.budgetedFees;
            this.allTotalBudgetedCost += resp.costsDetails.budgetedcost;
            this.allTotalBudgetedContribution += resp.costsDetails.budgetedcontribution;
            this.allTotalBudgetedContributionPer += resp.costsDetails.budgetedcontributionInPercentage;
            this.allTotalActualCost += resp.costsDetails.actualcost;
            this.allTotalActualContribution += resp.costsDetails.actualcostcontribution;
            this.allTotalActualContributionPer += resp.costsDetails.actualcostcontributionInPercentage;
            this.allTotalVarianceContribution += resp.costsDetails.varianceInContribution;
            this.allTotalVarianceContributionPer += resp.costsDetails.varianceInContributionInPercentage;

            this.allTotalBudgetedContributionPer = this.allTotalBudgetedFee - this.allTotalBudgetedCost;
            this.allTotalBudgetedContributionPer = this.allTotalBudgetedContributionPer / this.allTotalBudgetedFee;
            this.allTotalBudgetedContributionPer *= 100;
            this.allTotalBudgetedContributionPer = this.allTotalBudgetedContributionPer * 100 / 100;
            this.allTotalBudgetedContributionPer = Math.floor(this.allTotalBudgetedContributionPer);

            this.allTotalActualContributionPer = this.allTotalBudgetedFee - this.allTotalActualCost;
            this.allTotalActualContributionPer = this.allTotalActualContributionPer / this.allTotalBudgetedFee;
            this.allTotalActualContributionPer *= 100;
            this.allTotalActualContributionPer = this.allTotalActualContributionPer * 100 / 100;
            this.allTotalActualContributionPer = Math.floor(this.allTotalActualContributionPer);

            this.allTotalVarianceContributionPer = this.allTotalVarianceContribution / (this.allTotalBudgetedFee - this.allTotalBudgetedCost);
            this.allTotalVarianceContributionPer = this.allTotalVarianceContributionPer * 100;
            this.allTotalVarianceContributionPer = this.allTotalVarianceContributionPer * 100 / 100;
            this.allTotalVarianceContributionPer = Math.floor(this.allTotalVarianceContributionPer);

          });
          this.showExcelButton = true;
        });
      }
    }
    else {


      if (this.selectedLevel == "firmLevel") {
        if (this.selectedFinancialYear == null || this.selectedFinancialYear == undefined || this.selectedFinancialYear == "") {
          this.commonMessageService.swalAlertWithoutIcon('', 'Please select the year.');
          this.showExcelButton = false;
          this.reportList = undefined;
          return;
        }
        this.masterDataService.getVarianceSummaryReportByMandaysFirmLevel(this.selectedFinancialYear.id).subscribe((resp: any) => {
          console.log('mandays response details', resp);
          this.reportList = resp;
          
          
          this.showExcelButton = true;
          this.findDistinctRoles();
          this.calculateAllTotal();
        });
      } else {

        if (this.selectedFinancialYear == null || this.selectedFinancialYear == undefined || this.selectedFinancialYear == "" ||
          this.selectPartner == null || this.selectPartner == undefined || this.selectPartner == "") {
          this.commonMessageService.swalAlertWithoutIcon('', 'Please select the partner & year.');
          this.showExcelButton = false;
          this.reportList = undefined;
          return;
        }

        this.masterDataService.getVarianceSummaryReportByMandaysPartnerLevel(this.selectPartner.id,this.selectedFinancialYear.id).subscribe((resp: any) => {
          console.log('mandays response details', resp);
          this.reportList = resp;

          this.showExcelButton = true;
          this.findDistinctRolesforPartnerLevel();
          this.calculateAllTotalForPartnerLevel();
          // this.calculateAllTotal();
        });

        // if (this.selectedFinancialYear == null || this.selectedFinancialYear == undefined || this.selectedFinancialYear == "" ||
        //   this.selectPartner == null || this.selectPartner == undefined || this.selectPartner == "") {
        //   this.commonMessageService.swalAlertWithoutIcon('', 'Please select the partner & year.');
        //   this.showExcelButton = false;
        //   this.reportList = undefined;
        //   return;
        // }
        // this.masterDataService.getPartnerVarianceSummaryReport(this.selectedFinancialYear.id, this.selectPartner.id).subscribe((resp: any) => {
        //   console.log('partner response details', resp);
        //   this.reportList = resp;
        //   this.reportList.multi.map((resp: any) => {
        //     this.allTotalBudgetedFee += resp.budgetedFees;
        //     this.allTotalBudgetedCost += resp.costsDetails.budgetedcost;
        //     this.allTotalBudgetedContribution += resp.costsDetails.budgetedcontribution;
        //     this.allTotalBudgetedContributionPer += resp.costsDetails.budgetedcontributionInPercentage;
        //     this.allTotalActualCost += resp.costsDetails.actualcost;
        //     this.allTotalActualContribution += resp.costsDetails.actualcostcontribution;
        //     this.allTotalActualContributionPer += resp.costsDetails.actualcostcontributionInPercentage;
        //     this.allTotalVarianceContribution += resp.costsDetails.varianceInContribution;
        //     this.allTotalVarianceContributionPer += resp.costsDetails.varianceInContributionInPercentage;

        //     this.allTotalBudgetedContributionPer = this.allTotalBudgetedFee - this.allTotalBudgetedCost;
        //     this.allTotalBudgetedContributionPer = this.allTotalBudgetedContributionPer / this.allTotalBudgetedFee;
        //     this.allTotalBudgetedContributionPer *= 100;
        //     this.allTotalBudgetedContributionPer = this.allTotalBudgetedContributionPer * 100 / 100;
        //     this.allTotalBudgetedContributionPer = Math.floor(this.allTotalBudgetedContributionPer);

        //     this.allTotalActualContributionPer = this.allTotalBudgetedFee - this.allTotalActualCost;
        //     this.allTotalActualContributionPer = this.allTotalActualContributionPer / this.allTotalBudgetedFee;
        //     this.allTotalActualContributionPer *= 100;
        //     this.allTotalActualContributionPer = this.allTotalActualContributionPer * 100 / 100;
        //     this.allTotalActualContributionPer = Math.floor(this.allTotalActualContributionPer);

        //     this.allTotalVarianceContributionPer = this.allTotalVarianceContribution / (this.allTotalBudgetedFee - this.allTotalBudgetedCost);
        //     this.allTotalVarianceContributionPer = this.allTotalVarianceContributionPer * 100;
        //     this.allTotalVarianceContributionPer = this.allTotalVarianceContributionPer * 100 / 100;
        //     this.allTotalVarianceContributionPer = Math.floor(this.allTotalVarianceContributionPer);

        //   });
        //   this.showExcelButton = true;
        // });
      }


    }
  }
  

    
}
